import { Mutex } from 'async-mutex';
import { useCallback } from 'react';

import { toast } from '../../toasts';
import { RemoteAudioDelegator } from '../../video-sdk';
import { RestrictedAudioPlaybackToast } from './RestrictedAudioPlaybackToast';

const restrictedAudioPlaybackMutex = new Mutex();
const TOAST_KEY = 'restricted-audio-playback';

export function useShowRestrictedAudioPlaybackToastCallback() {
  const showRestrictedAudioPlaybackToast = useCallback(async () => {
    if (restrictedAudioPlaybackMutex.isLocked()) return;
    const release = await restrictedAudioPlaybackMutex.acquire();
    toast.enqueue((ariaProps) => <RestrictedAudioPlaybackToast {...ariaProps} onEnableAudio={release} />, {
      key: TOAST_KEY,
      onClose: release,
      purpose: 'system',
      timeout: Infinity,
    });
  }, []);

  const detectRestrictedAudioPlaybackTimeout = useCallback(
    (remoteAudio: RemoteAudioDelegator, audioElement: HTMLAudioElement, timeoutMs = 100) => {
      setTimeout(() => {
        const isUnexpectedlyPaused =
          remoteAudio.isEnabled && audioElement && audioElement.srcObject && !audioElement.ended && audioElement.paused;
        if (isUnexpectedlyPaused) {
          showRestrictedAudioPlaybackToast();
        }
      }, timeoutMs);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return {
    showRestrictedAudioPlaybackToast,
    detectRestrictedAudioPlaybackTimeout,
  };
}
